function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(9241 -8164)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 36,
  height: 36,
  transform: "translate(-9241 8164)",
  fill: "none"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-14774.632 5793.184)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5551.761,2398.55h-9.826a1.291,1.291,0,0,1-1.452-1.461q0-8.428,0-16.855c0-.785.466-1.239,1.166-1.145a.946.946,0,0,1,.854.907c.011.142,0,.285,0,.427q0,7.787,0,15.573c0,.534,0,.536.533.536q9.242,0,18.486,0a1.089,1.089,0,0,1,1.175.633.983.983,0,0,1-.882,1.384c-.4.016-.8,0-1.2,0Z",
  fill: "#707070",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5774.822,2403.256q0-2.564,0-5.128a.947.947,0,0,1,.962-1.07.962.962,0,0,1,1.039,1.049q.011,5.186,0,10.372a.958.958,0,0,1-1.082,1.041c-.589-.016-.917-.39-.917-1.058Q5774.821,2405.858,5774.822,2403.256Z",
  transform: "translate(-216.131 -16.583)",
  fill: "#71aff8",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5720.341,2399.561c0-.556-.017-1.112,0-1.667a1.016,1.016,0,0,1,1.5-.931.893.893,0,0,1,.511.812c.017,1.2.037,2.4,0,3.6a.984.984,0,0,1-1.031.989,1.049,1.049,0,0,1-.98-1.1C5720.325,2400.7,5720.341,2400.129,5720.341,2399.561Z",
  transform: "translate(-165.877 -16.381)",
  fill: "#71aff8",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5614.463,2489.629c0,.555.016,1.111,0,1.666a.969.969,0,0,1-1.095,1.063.9.9,0,0,1-.9-.754,1.752,1.752,0,0,1-.041-.345c0-1.085-.017-2.17,0-3.254a1,1,0,0,1,1.457-1.018,1.065,1.065,0,0,1,.577,1.016c0,.026,0,.052,0,.077q0,.775,0,1.55Z",
  transform: "translate(-66.347 -99.423)",
  fill: "#71aff8",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5666.633,2435.754c0-.569-.005-1.137,0-1.706a.945.945,0,0,1,.981-1.014.968.968,0,0,1,1.027,1.017q.012,1.726,0,3.451a1,1,0,1,1-2.009,0C5666.627,2436.917,5666.633,2436.336,5666.633,2435.754Z",
  transform: "translate(-116.347 -49.764)",
  fill: "#71aff8",
  fillRule: "evenodd"
})));

function SvgIconPpe(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPpe);
export default __webpack_public_path__ + "static/media/icon-ppe.22b10aec.svg";
export { ForwardRef as ReactComponent };